import * as React from 'react'
import Button from '@mui/material/Button'
import { LeadAttachmentsButtonProps } from './typings'
import { AttachmentPaperClipIcon } from '@sales-center/components'

export const LeadAttachmentsButton: React.FC<LeadAttachmentsButtonProps> = (
  props,
) => {
  const { sx, onOpenAttachments } = props

  return (
    <Button
      sx={sx}
      onClick={onOpenAttachments}
      variant="outlined"
      startIcon={<AttachmentPaperClipIcon />}
    >
      Attachments
    </Button>
  )
}
LeadAttachmentsButton.displayName = 'LeadAttachmentsButton'
